export default "__VITE_ASSET__DjVAHNno__"